import { Campaign } from 'modules/domains/campaign';
import { CampaignCell } from './CampaignCell';
import { PercentageCell } from './PercentageCell';
import { HighestConversionCampaign } from '../../../../types';

type RowProps = {
  campaignId: Campaign['id'];
  campaignName: Campaign['name'];
  conversionRate: HighestConversionCampaign['conversionRate'];
  rowIndex: number;
};

export const Row = ({ campaignName, campaignId, conversionRate, rowIndex }: RowProps) => (
  <>
    <CampaignCell campaign={campaignName} id={campaignId} rowIndex={rowIndex} />
    <PercentageCell count={conversionRate} rowIndex={rowIndex} />
  </>
);
